import { stepMedicalExpenseCFLookup as expenseLookup } from './claimCodeMapper';

function mapToParentSection() {
  return {};
}

function mapToQuestionnaire(data, claimCode) {
  const questionnaire = [];
  const entries = Object.entries(data);
  const excludedEntries = ['prescriptionMedicinesNotInjury',
    'prescriptionMedicinesForInjury',
    'lossInformationItemsMedicalExpense',
  ];
  entries.forEach(([property, value]) => {
    if (excludedEntries.indexOf(property) < 0) {
      questionnaire.push({
        question: `medicalExpenseCF.${property}`,
        answer: value,
        claimTypeCode: claimCode,
      });
    }
  });
  return [...questionnaire];
}

function mapToExpenses(data) {
  const medicalExpenses = mapToMedicalExpenseStep(data);
  return [...medicalExpenses];
}

function mapToClaimExpensesLevel(data, claimTypes, selectedBenefits) {
  const selected =
    !!selectedBenefits && typeof selectedBenefits.toJS === 'function'
      ? selectedBenefits.toJS()
      : selectedBenefits || [];
  const { lossInformationItemsMedicalExpense } = data;
  const claimCode = expenseLookup.medicalExpenseCF.claimCode;
  const claimCodeList = expenseLookup.claimCodeList;
  const list = [];
  if (selected.length > 0 && !selected.some((sel) => claimCodeList.includes(sel.claimCode))
  ) {
    return list;
  }

  if (lossInformationItemsMedicalExpense.length < 1) {
    return list;
  }
  const medicalExpenses = mapToMedicalExpenseStep(data);

  claimTypes.forEach(
    (item) => {
      if (item.claimCode === claimCode) {
        const benefit = mapClaimExpensesLevelItem(item, 'Medical Expense', medicalExpenses);
        if (!!benefit) {
          list.push(benefit);
        }
      }
    }
  );

  return list;
}

function mapToMedicalExpenseStep(data) {
  const expenses = [];
  const lossInformationItems = data.lossInformationItemsMedicalExpense || [];

  if (lossInformationItems.length < 1) {
    return expenses;
  }

  const claimCode = expenseLookup.medicalExpenseCF.claimCode;
  lossInformationItems.forEach(
    (item) => {
      const expense = mapLossItemExpense(item, data, claimCode);
      if (!!expense) {
        expenses.push(expense);
      }
    }
  );
  return expenses;
}

function mapLossItemExpense(item, formData, claimCode) {
  return mapExpenseItem(item, formData.dateIncurred, claimCode);
}

function mapExpenseItem(item, itemDate, claimCode) {
  const selectedClaimForArray = item.selectedClaimFor ? (!Array.isArray(item.selectedClaimFor)) ? item.selectedClaimFor.toJS() : item.selectedClaimFor : [];
  const claimForInsuredIds = selectedClaimForArray.map((claimFor) => claimFor.policyRoleID);
  if (!item || !item.actualCostForHospital || !item.currencyForHospital) {
    return null;
  }
  return {
    benefitName: 'Medical Expense',
    shortDescription: `${item.medicalProviderName}`,
    dateOfExpense: item.expenseDateForHospital,
    clientCost: item.actualCostForHospital,
    currency: item.currencyForHospital,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
    claimForInsuredIds,
    claimForInsureds: selectedClaimForArray,
  };
}

function mapClaimExpensesLevelItem(claimType, description, expenses) {
  return {
    claimCode: claimType.claimCode,
    description,
    claimTypeId: claimType.claimTypeId,
    requiredDocuments: claimType.requiredDocuments,
    order: null,
    expenses: expenses || [],
  };
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
  mapToClaimExpensesLevel,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepMedicalExpenseCFDataMapper.js